import {
    Component,
    ViewChild,
    ViewEncapsulation,
    OnInit,
    Input,
    Inject,
} from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../lib/api.service';
import { LogService } from '../../../lib/log.service';
import { ModalService } from '../../../lib/modal.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    Course,
    Chapter,
    Video,
    Attachment,
    AudioCourse,
} from '../../../models/course';

@Component({
    selector: 'app-course-burning-question-edit',
    templateUrl: './course-burning-question-edit.component.html',
    styleUrls: ['./course-burning-question-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CourseBurningQuestionEditComponent implements OnInit {
    @ViewChild('input') fileInput: any;
    courseEditForm: FormGroup;
    courseStoryId: number;
    courseKey: string;
    title: string;
    mode: string;
    // course: Course;
    course: AudioCourse;
    isLoaded: boolean = false;
    config: any;
    panelState: Array<boolean>;
    submitButtonPressed: boolean = false;
    errors: string = '';
    categoryList: any;
    showQuestionFrench = false;
    showQuestionSpanish = false;
    showCounselorNameFrench = false;
    showCounselorNameSpanish = false;
    showDescFrench = false;
    showDescSpanish = false;
    showError: boolean = false;
    audioerror: boolean = false;

    constructor(
        private translate: TranslateService,
        private formBuilder: FormBuilder,
        private api: ApiService,
        private log: LogService,
        private modalService: ModalService,
        public dialogRef: MatDialogRef<CourseBurningQuestionEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        dialogRef.disableClose = true;
        this.courseStoryId = data.data;
        this.panelState = [];

        if (this.courseStoryId) {
            this.title = 'Edit this Burning Question';
            this.mode = 'update';
        } else {
            this.title = 'Create a Burning Question';
            this.course = new AudioCourse({});
            this.mode = 'create';
            this.isLoaded = true;
        }

        this.createCourseEditForm(new AudioCourse({}));

        this.config = {
            toolbar: [
                { name: 'formatting', items: ['PasteFromWord'] },
                {
                    name: 'basicstyles',
                    items: ['Bold', 'Italic', 'Underline', 'Strike', '-'],
                },
                { name: 'links', items: ['Link', 'Unlink'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
            ],
        };
    }

    get f() {
        return this.courseEditForm.controls;
    }

    createCourseEditForm(data: any) {
        this.courseEditForm = this.formBuilder.group({
            id: [data.id || null],
            titleen: [data.titleen || '', [Validators.required]],
            titlefr: [data.titlefr || ''],
            titlees: [data.titlees || ''],
            authoren: [data.authoren || '', [Validators.required]],
            authorfr: [data.authorfr || ''],
            authores: [data.authores || ''],
            category: [data.category || '', [Validators.required]],
            transcripten: [data.transcripten || '', [Validators.required]],
            transcriptfr: [data.transcriptfr || ''],
            transcriptes: [data.transcriptes || ''],
            isCompleted: [data.isCompleted || false],
            default: [data.default || false],
            active: [data.active || false],
            audio: this.createFileUpload(data.audio),
            image: this.createFileUpload(data.image),
            audioUrl: [data.audioURL || ''],
            imageUrl: [data.imageURL || ''],
        });
    }

    get audioFileUpload(): FormArray {
        return this.courseEditForm.get('audio') as FormArray;
    }

    ngOnInit() {
        this.api.get('series/categories').subscribe(
            (result: any) => {
                this.categoryList = result;
                this.isLoaded = true;
            },
            (error: any) => {
                this.log.error('Error getting organizations. ' + error.message);
            }
        );
        if (this.courseStoryId) {
            this.api
                .get('series/burningquestion/' + this.courseStoryId)
                .subscribe(
                    (result: any) => {
                        this.course = new AudioCourse(result[0]);
                        this.isLoaded = true;
                        this.createCourseEditForm(this.course);
                        this.showQuestionFrench = !!this.course.titlefr?.trim();
                        this.showQuestionSpanish =
                            !!this.course.titlees?.trim();
                        this.showCounselorNameFrench =
                            !!this.course.authorfr?.trim();
                        this.showCounselorNameSpanish =
                            !!this.course.authores?.trim();
                        this.showDescFrench =
                            !!this.course.transcriptfr?.trim();
                        this.showDescSpanish =
                            !!this.course.transcriptes?.trim();
                        this.isLoaded = true;
                    },
                    (error: any) => {
                        this.log.error(
                            'Error getting organizations. ' + error.message
                        );
                    }
                );
        }
    }

    toggleField(language: string, field: string) {
        if (language === 'French') {
            if (field === 'Question')
                this.showQuestionFrench = this.course?.titlefr?.trim()
                    ? true
                    : !this.showQuestionFrench;
            else if (field === 'Counselor Name')
                this.showCounselorNameFrench = this.course?.authorfr?.trim()
                    ? true
                    : !this.showCounselorNameFrench;
            else if (field === 'Description')
                this.showDescFrench = this.course?.transcriptfr?.trim()
                    ? true
                    : !this.showDescFrench;
        } else if (language === 'Spanish') {
            if (field === 'Question')
                this.showQuestionSpanish = this.course?.titlees?.trim()
                    ? true
                    : !this.showQuestionSpanish;
            else if (field === 'Counselor Name')
                this.showCounselorNameSpanish = this.course?.authores?.trim()
                    ? true
                    : !this.showCounselorNameSpanish;
            else if (field === 'Description')
                this.showDescSpanish = this.course?.transcriptes?.trim()
                    ? true
                    : !this.showDescSpanish;
        }
    }

    changeAudioUploadListener($event): void {
        this.readFile($event.target, 'audio', 'mp3');
    }

    readFile(
        inputValue: any,
        keyFileName: string,
        allowedTypes: string = 'mp3'
    ) {
        var file: File = inputValue.files[0];
        let fileName = file.name;
        var reader: FileReader = new FileReader();
        const maxFileSize = 25 * 1024 * 1024;
        const extPattern = new RegExp(`\.(${allowedTypes})$`, 'i');

        if (!extPattern.test(fileName)) {
            this.modalService.showAlert(
                'Error',
                `Invalid file extension. Allowed: ${allowedTypes}`
            );
            inputValue.value = '';
            return;
        }

        if (file.size > maxFileSize) {
            this.modalService.showAlert(
                'Error',
                `File size exceeds 25MB. Please upload a smaller file.`
            );
            inputValue.value = '';
            return;
        }

        reader.onloadend = () => {
            const audioList = this.courseEditForm.get(keyFileName) as FormGroup;

            audioList.patchValue({
                fileUpload: reader.result,
                fileFilename: fileName,
            });
        };

        reader.readAsDataURL(file);
    }

    courseImageUpload($event) {
        var file: File = $event.target.files[0];
        $event.target.files[0];
        let fileName = $event.target.files[0].name;
        var reader: FileReader = new FileReader();
        const maxFileSize = 5 * 1024 * 1024;
        const courseImage = this.courseEditForm.get('image') as FormGroup;
        if (!/\.(jpg|jpeg)$/i.test(fileName)) {
            this.fileInput.nativeElement.value = '';
            this.modalService.showAlert(
                'Error',
                'Please ensure that the file you are uploading is in .jpg format.'
            );
            return;
        }

        if (file.size > maxFileSize) {
            this.fileInput.nativeElement.value = '';
            this.modalService.showAlert(
                'Error',
                'The file size exceeds the maximum limit of 2MB.'
            );
            return;
        }

        reader.onloadend = () => {
            courseImage.patchValue({
                fileUpload: reader.result,
                fileFilename: fileName,
            });
        };

        reader.readAsDataURL(file);
    }

    validateEditor() {
        const transcriptControl = this.courseEditForm.get('transcripten');

        if (transcriptControl?.value.trim() === '') {
            transcriptControl.setErrors({ required: true });
        } else {
            transcriptControl.setErrors(null);
        }
    }

    doSave() {
        this.course = new AudioCourse(this.courseEditForm.value);
        this.submitButtonPressed = true;
        if (!this.courseEditForm.valid) {
            this.courseEditForm.markAllAsTouched();
            return;
        }
        this.errors = '';
        this.audioerror = false;
        const hasTranscript = ['transcripten'].some(field =>
            this.courseEditForm.get(field)?.value.trim()
        );

        if (!hasTranscript) {
            this.errors =
                'At least one of the Transcript fields (English) must be filled.';
        }
        if (
            !this.courseEditForm.value.audio.fileFilename &&
            !this.courseEditForm.value.audio.fileUpload &&
            !this.courseEditForm.value.audioUrl
        ) {
            this.audioerror = true;
            this.errors = `The audio file is mandatory`;
        }
        if (this.errors || this.audioerror) {
            // errors = "The following errors were found:<br>" + errors;
            // this.modalService.showAlert("Error", errors);
            return;
        }
        this.isLoaded = false;
        if (this.mode === 'update') {
            this.api
                .put(
                    'series/burningquestion/' + this.courseStoryId,
                    AudioCourse.forAPI(this.course),
                    true
                )
                .subscribe(
                    (data: any) => {
                        this.modalService.showAlert(
                            'Success',
                            'Series has been updated'
                        );
                        this.isLoaded = true;
                        this.dialogRef.close(this.course);
                    },
                    (error: any) => {
                        this.isLoaded = true;
                        this.modalService.showAlert(
                            'Error',
                            'Something went wrong. ' + error.message
                        );
                    }
                );
        } else {
            this.api
                .post(
                    'series/burningquestion',
                    AudioCourse.forAPI(this.course),
                    true
                )
                .subscribe(
                    (data: any) => {
                        this.modalService.showAlert(
                            'Success',
                            'Series has been created'
                        );
                        this.isLoaded = true;
                        this.dialogRef.close(data);
                    },
                    (error: any) => {
                        this.isLoaded = true;
                        this.modalService.showAlert(
                            'Error',
                            'Something went wrong. ' + error.message
                        );
                    }
                );
        }
    }

    createFileUpload(data: any) {
        return this.formBuilder.group({
            fileUpload: [data.fileUpload || null],
            fileFilename: [data.fileFilename || ''],
        });
    }

    onClose() {
        this.dialogRef.close();
    }
}
